

// const searchInput = document.getElementById('countrySearch');
// const countryList = document.getElementById('countryList');
// const countryItems = [...countryList.querySelectorAll('li')];
// const hiddenInput = document.getElementById('selectedCountry');
// const noResult = document.getElementById('noResultMessage');
// const selecter = document.querySelector('.select-input.country-input-selecter');
// const inputBox = document.querySelector('.select-input.country-input');
// const uls = document.querySelectorAll('[country_ul]');

// const toggleDisplay = (el, show) => el.style.display = show ? 'block' : 'none';
// const showAll = () => countryItems.forEach(li => li.style.display = 'block');

// searchInput.addEventListener('focus', () => {
//   selecter.classList.add('hidden');
//   inputBox.classList.remove('hidden');
//   toggleDisplay(countryList, false);
//   toggleDisplay(noResult, false);
// });

// searchInput.addEventListener('input', () => {
//   const val = searchInput.value.trim().toLowerCase();
//   if (!val) {
//     selecter.classList.remove('hidden');
//     inputBox.classList.remove('hidden');
//     toggleDisplay(countryList, false);
//     toggleDisplay(noResult, false);
//     showAll();
//     return;
//   }

//   selecter.classList.add('hidden');
//   inputBox.classList.add('hidden');
//   let found = false;
//   countryItems.forEach(li => {
//     const match = li.textContent.toLowerCase().includes(val);
//     li.style.display = match ? 'block' : 'none';
//     if (match) found = true;
//   });
//   toggleDisplay(countryList, found);
//   toggleDisplay(noResult, !found);
// });

// countryItems.forEach(li =>
//   li.addEventListener('click', () => {
//     searchInput.value = li.textContent;
//     hiddenInput.value = li.dataset.value;
//     selecter.classList.remove('hidden');
//     inputBox.classList.remove('hidden');
//     toggleDisplay(countryList, false);
//     toggleDisplay(noResult, false);
//   })
// );

// document.addEventListener('click', e => {
//   if (!searchInput.contains(e.target) && !countryList.contains(e.target)) {
//     selecter.classList.add('hidden');
//     inputBox.classList.remove('hidden');
//     toggleDisplay(countryList, false);
//     toggleDisplay(noResult, false);
//   }
// });

// // Initialize
// selecter.classList.remove('hidden');
// inputBox.classList.remove('hidden');
// toggleDisplay(countryList, false);
// toggleDisplay(noResult, false);

// // Country dropdown logic
// uls.forEach(ul => {
//   const lis = ul.querySelectorAll('li');
//   lis.forEach((li, i) => (i !== 0 || !li.hasAttribute('disabled')) && (li.style.display = 'none'));

//   const trigger = ul.querySelector('li[disabled]');
//   if (!trigger) return;

//   trigger.addEventListener('click', () => {
//     const open = ul.classList.toggle('active');
//     uls.forEach(u => {
//       if (u !== ul) {
//         u.classList.remove('active');
//         u.querySelectorAll('li:not([disabled])').forEach(li => li.style.display = 'none');
//       }
//     });
//     lis.forEach((li, i) => {
//       if (i !== 0 || !li.hasAttribute('disabled'))
//         li.style.display = open ? 'block' : 'none';
//     });
//   });
// });

// =------------------------------------------------------

class CustomLocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.searchInput = this.querySelector('#countrySearch');
    this.countryList = this.querySelector('#countryList');
    this.countryItems = this.countryList
      ? [...this.countryList.querySelectorAll('li')]
      : [];
    this.hiddenInput = this.querySelector('#selectedCountry');
    this.noResult = this.querySelector('#noResultMessage');
    this.selecter = this.querySelector(
      '.select-input.country-input-selecter'
    );
    this.inputBox = this.querySelector('.select-input.country-input');
    this.uls = this.querySelectorAll('[country_ul]');
  }

  toggleDisplay(el, show) {
    if (el) {
      el.style.display = show ? 'block' : 'none';
    }
  }

  showAll() {
    this.countryItems.forEach((li) => {
      li.style.display = 'block';
    });
  }

  initCountrySearch() {
    if (!this.searchInput || !this.countryList) return;

    this.searchInput.addEventListener('focus', () => {
      this.selecter?.classList.add('hidden');
      this.inputBox?.classList.remove('hidden');

      this.toggleDisplay(this.countryList, false);
      this.toggleDisplay(this.noResult, false);
    });

    this.searchInput.addEventListener('input', () => {
      const val = this.searchInput.value.trim().toLowerCase();

      if (!val) {
        this.selecter?.classList.remove('hidden');
        this.inputBox?.classList.remove('hidden');

        this.toggleDisplay(this.countryList, false);
        this.toggleDisplay(this.noResult, false);

        this.showAll();
        return;
      }

      this.selecter?.classList.add('hidden');
      this.inputBox?.classList.add('hidden');

      let found = false;

      this.countryItems.forEach((li) => {
        const match = li.textContent.toLowerCase().includes(val);

        li.style.display = match ? 'block' : 'none';

        if (match) {
          found = true;
        }
      });

      this.toggleDisplay(this.countryList, found);
      this.toggleDisplay(this.noResult, !found);
    });

    this.countryItems.forEach((li) => {
      li.addEventListener('click', () => {
        this.searchInput.value = li.textContent.trim();
        this.hiddenInput.value = li.dataset.value || '';

        this.selecter?.classList.remove('hidden');
        this.inputBox?.classList.remove('hidden');

        this.toggleDisplay(this.countryList, false);
        this.toggleDisplay(this.noResult, false);
      });
    });

    document.addEventListener('click', (event) => {
      if (
        !this.searchInput.contains(event.target) &&
        !this.countryList.contains(event.target)
      ) {
        this.selecter?.classList.add('hidden');
        this.inputBox?.classList.remove('hidden');

        this.toggleDisplay(this.countryList, false);
        this.toggleDisplay(this.noResult, false);
      }
    });

    // Initial state
    this.selecter?.classList.remove('hidden');
    this.inputBox?.classList.remove('hidden');

    this.toggleDisplay(this.countryList, false);
    this.toggleDisplay(this.noResult, false);
  }

  initCountryDropdowns() {
    this.uls.forEach((ul) => {
      const lis = ul.querySelectorAll('li');

      lis.forEach((li, index) => {
        if (index !== 0 || !li.hasAttribute('disabled')) {
          li.style.display = 'none';
        }
      });

      const trigger = ul.querySelector('li[disabled]');

      if (!trigger) return;

      trigger.addEventListener('click', () => {
        const open = ul.classList.toggle('active');

        // Close other dropdowns
        this.uls.forEach((otherUl) => {
          if (otherUl !== ul) {
            otherUl.classList.remove('active');

            otherUl
              .querySelectorAll('li:not([disabled])')
              .forEach((li) => {
                li.style.display = 'none';
              });
          }
        });

        // Toggle current dropdown
        lis.forEach((li, index) => {
          if (index !== 0 || !li.hasAttribute('disabled')) {
            li.style.display = open ? 'block' : 'none';
          }
        });
      });
    });
  }

  connectedCallback() {
    this.initCountrySearch();
    this.initCountryDropdowns();
  }
}

customElements.define(
  'custom-localization-form',
  CustomLocalizationForm
);

// function metfilds_update() {
//   const get_customer = document.querySelector('body').getAttribute('data-customer-id');
// console.log(get_customer,'get_customer')
//   if (get_customer) {
//     const rawCustshirtConfig = JSON.parse(localStorage.getItem('custshirtConfig'));
//     const rawShirtConfig = JSON.parse(localStorage.getItem('shirtConfig'));
    
//     console.log(!rawCustshirtConfig || !rawShirtConfig);

//     if (rawCustshirtConfig || rawShirtConfig) {
//     // } else {
//       const custshirtConfig = rawCustshirtConfig.custbespokeshirt || rawCustshirtConfig;
//       const shirtConfig = rawShirtConfig?.bespokeshirt || null;

//       const combinedConfig = {
//         custshirtConfig: custshirtConfig,
//         shirtConfig: shirtConfig
//       };

//       const formdata = new FormData();
//       formdata.append("customer_id", get_customer);
//       formdata.append("json", JSON.stringify(combinedConfig));

//       console.log("FormData JSON:", JSON.stringify(combinedConfig));

//       const requestOptions = {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       };

//       fetch("https://kow.dfm.temporary.site/website_e5e4703e/Draftorder/update_metafield.php", requestOptions)
      
//         .then((response) => response.text())
//         .then((result) => console.log(result))
//         .catch((error) => console.error(error));
//     }
//   }
// }



function metfilds_update(Profile_json=null, element=null,it_submitfrom=false, updateajax=false ) {
  const get_customer = document.querySelector('body').getAttribute('data-customer-id');

          localStorage.setItem('customerprofiles', JSON.stringify(window.customer_data));

  if (get_customer) {

    if(!Profile_json){
      Profile_json = window.customer_data
    }
      const formdata = new FormData();
      formdata.append("customer_id", get_customer);
      formdata.append("json", JSON.stringify(Profile_json));

      console.log("FormData JSON:", JSON.stringify(Profile_json));

      const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
      };

      fetch("https://kow.dfm.temporary.site/website_e5e4703e/Draftorder/update_metafield.php", requestOptions)
      
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.error(error))
         .finally(() => {

          if(element){
            element.removeAttribute("disabled");
           element.classList.remove("loadding");
           document.body.classList.remove("loadding");
          }
           if(!it_submitfrom){
            //  window.location.reload();
              const url = new URL(window.location.href);
                      url.searchParams.set('savefrom', 'true');
                      window.location.href = url.toString();

           }

           if(updateajax){
            renderCustomerProfiles(true);
           }

         });
    }
  }






function file_upload_PHP(file,input) { 

  const input_set = document.querySelector(`${input.getAttribute("data-fild_id")}`);
  const time_stamp = new Date().getTime();
  console.log(file);

  if(!input_set) return;
  
const formdata = new FormData();
formdata.append("file", file, file.name );
console.log(formdata);
const requestOptions = {
  method: "POST",
  body: formdata,
  redirect: "follow"
};
console.log(requestOptions);
fetch("https://kow.dfm.temporary.site/website_e5e4703e/bespoketshirtmakers/createfile.php", requestOptions)

  .then((response) => response.json())
  .then((result) => {
          console.log(result.url);
    input_set.value = result.url;
    
  })
  .catch((error) => console.error(error));
  
}


function file_upload_PHP_multiple(files, input) {

  const input_set = document.querySelector('input[data-fild_id]');



  if (!input_set || !files || files.length === 0) {
    return;
  }

  const formdata = new FormData();

  // Add all selected files
  Array.from(files).forEach((file) => {
    formdata.append("files[]", file, file.name);
  });

  input_set.value = "Uploading...";

  document.body.classList.add("file_uploading");

  fetch(
    "https://kow.dfm.temporary.site/website_e5e4703e/bespoketshirtmakers/createmultiplefile.php",
    {
      method: "POST",
      body: formdata
    }
  )
    .then((response) => response.json())
    .then((result) => {

      console.log("Upload result:", result);

      if (result.success && result.urls) {

        // Store all Shopify image URLs
         const uploadedFilesJSON = JSON.stringify(result.urls);

        // Store JSON inside Shopify line item property
        input_set.value = uploadedFilesJSON;
        // input_set.value = result.urls.join(", ");

        console.log("Uploaded URLs:", result.urls);

      } else {

        input_set.value = "";

        console.error(
          result.message || "File upload failed.",
          result
        );
      }
        document.body.classList.remove("file_uploading");
    })
    .catch((error) => {

      input_set.value = "";

      console.error("Upload error:", error);
      document.body.classList.remove("file_uploading");
    });
}

// (function() {
// // metfilds_update();

//   const filted_upload_check =  document.querySelectorAll('[data-filed-upload]') || null;
//     if(filted_upload_check){
//       filted_upload_check.forEach(item => {
//             item.addEventListener('change', (e) => {
//               console.log(e);
         
              
//               const file = e.target.files[0];
//               // var extension = files[0].type;
//               // console.log(file);
//               file_upload_PHP(file,e.target);
//                  const removeborder = e.target.closest('.size_input_main');
//               removeborder.style.border = '0rem solid transparent';
//            });
//         });
//     } 
  
// })();




// -----------------collection page swatch-------------
const radiobtn = document.querySelectorAll('.Product_vairant input');
  radiobtn.forEach(radiobtns => {
  radiobtns.addEventListener('click', function (event) {
      
    const imgget = this.getAttribute("data-img");
      if (imgget && imgget.trim() !== "") {
        const closestdiv = this.closest('product-card');
        const addimg = closestdiv.querySelector('img');
        console.log("addimg",addimg);
        addimg.src = imgget;
        addimg.srcset = imgget;
      }
  });
});

// size enter logic product page
  (function () {

    function getSizeInputs() {
      return Array.from(
        document.querySelectorAll('.size_new_input input.input')
      ).filter(function (input) {
        return !input.disabled && input.offsetParent !== null;
      });
    }

    function validateCurrentInput(input) {
      if (!input) return false;

      const wrapper = input.closest('.fit.style-input');
      const error = wrapper?.querySelector('.form-error');

      const value = input.value.trim();

      // ONLY current input validation
      const invalid = value === '' || isNaN(parseFloat(value));

      if (wrapper) {
        wrapper.classList.toggle('error', invalid);
      }

      if (error) {
        error.style.display = invalid ? 'block' : 'none';
      }

      return !invalid;
    }


    /*
    * IMPORTANT
    * Capture Enter before Shopify/theme form handlers.
    */
    document.addEventListener('keydown', function (e) {

      if (e.key !== 'Enter') return;

      const input = e.target.closest(
        '.size_new_input input.input'
      );

      if (!input) return;

      // STOP browser + Shopify form submit
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Validate ONLY current input
      if (!validateCurrentInput(input)) {
        input.focus();
        return false;
      }

      const inputs = getSizeInputs();

      const currentIndex = inputs.indexOf(input);

      if (currentIndex === -1) return false;

      const nextInput = inputs[currentIndex + 1];

      if (nextInput) {

        // Move to next input
        nextInput.focus();

        // Select current value if any
        nextInput.select();

      } else {

        // Last input
        // NEVER submit on Enter
        input.blur();
      }

      return false;

    }, true);


    /*
    * Extra protection:
    * Stop submit if Enter somehow reaches the form.
    */
    document.addEventListener('submit', function (e) {

      const activeElement = document.activeElement;

      if (
        activeElement &&
        activeElement.matches('.size_new_input input.input')
      ) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Validate ONLY active/current input
        validateCurrentInput(activeElement);

        activeElement.focus();

        return false;
      }

    }, true);


    /*
    * Remove error only for the input being edited.
    */
    document.addEventListener('input', function (e) {

      const input = e.target.closest(
        '.size_new_input input.input'
      );

      if (!input) return;

      const wrapper = input.closest('.fit.style-input');
      const error = wrapper?.querySelector('.form-error');

      if (input.value.trim() !== '') {

        wrapper?.classList.remove('error');

        if (error) {
          error.style.display = 'none';
        }

      }

    });

  })();
function submt_custom_click(This,frombutton=null,addticart = false) {

if(!This) return true;
  const submit_from = This.closest('product-info').querySelector('product-form')|| null;
  if(!submit_from) return true;
const originalButton = submit_from.querySelector('.product-form [type="submit"].product-form__submit');
const massage = This.getAttribute('data-massage') || null;
const savedata = This.hasAttribute('data-save') || false;
// const popup_open = This.hasAttribute('data-save-popup-shaow') || false;
const popup_open = false;


if (submit_from ) {
  // customButton.addEventListener('click', function (e) {
    // e.preventDefault();
    let isValid = true;
    let allSizeInputsValid = true;


    // 🔹 1. Validate normal required sections
    const allGroups = document.querySelectorAll('.custom-required-check');

  
   
    allGroups.forEach(group => {
      const inputs = group.querySelectorAll('input');
      console.log(inputs,'inputs');
     
      if (inputs.length === 0) return false;

      const match = inputs[0].name.match(/properties\[(.*?)\]/);
      const fieldName = match ? match[1] : '';
      let errorElement = group.querySelector('.form-error');
      if (!errorElement) return false;

      let hasValue = [...inputs].some(input =>
        (input.type === 'radio' || input.type === 'checkbox') ? input.checked :
        (input.type === 'text' || input.type === 'number') ? input.value.trim() !== "" : false
      );

      if (!hasValue) {
        isValid = false;
        errorElement.textContent = `Please select ${fieldName}`;
        errorElement.style.display = 'block';
      } else {
        errorElement.style.display = 'none';
      }
    });


     // 🔹 1.1. Validate normal required sections
                      const allGroups_new_new = document.querySelectorAll(".monogram-input-default");

                            allGroups_new_new.forEach((group) => {
                              const inputs = group.querySelectorAll("input");
                              console.log(inputs, "inputs");

                              if (inputs.length === 0) return;

                              const match = inputs[0].name.match(/properties\[(.*?)\]/);
                              const fieldName = match ? match[1] : "";

                              let errorElement = group.querySelector(".form-error");

                              if (!errorElement) return;

                              const hasValue = [...inputs].some((input) => {
                                if (input.type === "radio" || input.type === "checkbox") {
                                  return input.checked;
                                }

                                if (input.type === "text" || input.type === "number") {
                                  return input.value.trim() !== "";
                                }

                                return false;
                              });

                              if (!hasValue) {
                                isValid = false;
                                
                                errorElement.style.display = "block";
                              } else {
                                errorElement.style.display = "none";
                              }
                            });


    // 🔹 2. Validate size inputs (highlight red border if empty)
    const sizeInputs = document.querySelectorAll('.size-container .size_new_input input,#profile_name');
    sizeInputs.forEach(inp => {
      const parent = inp.closest('.size_new_input');
       const fitInput = inp.closest('.fit.style-input');
      const value = parseFloat(inp.value);
              const min = parseFloat(inp.min);
              const max = parseFloat(inp.max);
      if (parent) {



        let isInvalid = false;
              if (inp.type === 'text') {
                      isInvalid = (inp.value === '')? true : false;
                      
                    } else{

                        isInvalid =
                        inp.value.trim() === '' ||
                        isNaN(value);


                        // isInvalid =
                        // inp.value.trim() === '' ||
                        // isNaN(value) ||
                        // isNaN(min) ||
                        // isNaN(max) ||
                        // value < min ||
                        // value > max;


                    }

      console.log('isInvalid',isInvalid);

        if (isInvalid) {
           fitInput?.classList.add('error');
          allSizeInputsValid = false;
          isValid = false;
          
        } else {
          fitInput?.classList.remove('error');
          parent.style.border = '';
        }
      }
    });

    // move on next input enter click product page size
   function validateSizeInput(inp) {
      const fitInput = inp.closest('.fit.style-input');
      let invalid;

      if (inp.type === 'text') {
        invalid = inp.value.trim() === '';
      } else {
        invalid = inp.value.trim() === '' || isNaN(parseFloat(inp.value));
      }

      if (fitInput) fitInput.classList.toggle('error', invalid);
      return !invalid;
    }
   
    // 🔹 3. Manage step visibility
    const sizeContainer = document.querySelector('.size-container');
    const styleContainer = document.querySelector('.style-container');

    const tabMeasurement = document.querySelector('label.tab[for="measurement"]');
    const tabCustomize = document.querySelector('label.tab[for="customize"]');

    if (sizeContainer && styleContainer) {
      if (allSizeInputsValid) {
        // sizeContainer.style.display = 'none';
        // styleContainer.style.display = 'block';

        // ✅ Switch tab active state
        if (tabMeasurement) tabMeasurement.classList.remove('active');
        if (tabCustomize) tabCustomize.classList.add('active');

      } else {
        // sizeContainer.style.display = 'block';
        // styleContainer.style.display = 'none';

        // ⛔ Keep measurement tab active
        if (tabMeasurement) tabMeasurement.classList.add('active');
        if (tabCustomize) tabCustomize.classList.remove('active');

        // return false; // stop further validation
      }
    }



    // 🔹 4. Check if "With Monogram" is selected
    const withMonogram = document.querySelector('.monogram-options-custom input[value="With Monogram"]:checked');
 
    if (withMonogram) {
      const monogramSection = document.querySelector('#Monogram_Detail');
      if (monogramSection && window.getComputedStyle(monogramSection).display !== 'none') {
        const monogramGroups = monogramSection.querySelectorAll('.d-flex');

        monogramGroups.forEach(group => {
          const inputs = group.querySelectorAll('input');
          if (inputs.length === 0) return false;

          const match = inputs[0].name.match(/properties\[(.*?)\]/);
          const fieldName = match ? match[1] : '';

          let errorElement = group.querySelector('.form-error');
          if (!errorElement) {
            errorElement = document.createElement('p');
            errorElement.className = 'form-error';
            Object.assign(errorElement.style, {
              color: 'red', fontSize: '13px', marginTop: '4px'
            });
            group.appendChild(errorElement);
          }

          let hasValue = [...inputs].some(input =>
            (input.type === 'radio' || input.type === 'checkbox') ? input.checked :
            (input.type === 'text' || input.type === 'number') ? input.value.trim() !== "" : false
          );

          if (!hasValue) {
            isValid = false;
            errorElement.textContent = `Please select ${fieldName}`;
            errorElement.style.display = 'block';
          } else {
            errorElement.style.display = 'none';
          }
        });
      }
    }

    // ✅ 5. Submit only if all valid
    if (isValid) {

      console.log("isValid",isValid,"isValid");

This.classList.remove('fillsize');
      if(savedata && popup_open){
           updateeditprofile(This,savedata,popup_open);
      }else if (savedata) {
        //  close_custom_drawer();
         updateeditprofile(This,savedata,popup_open);
        //  if(massage){
        //       const massage_el = document.querySelector('.size-guide-success-massage .message p') || null;
        //       if(massage_el) massage_el.innerText = massage;

        //     }
     
      }else{

        if (!document.body.classList.contains('template--customizable-product')){
          if(originalButton){
            originalButton.click();
            close_custom_drawer();
          } 
          }

         close_size_profile_drawer();
          originalButton.classList.remove('fillsize');
         originalButton?.removeAttribute('disabled');
      }
       return true;

       
      // if(!frombutton){
      //   if(addticart)         originalButton.click();
      //   // document.querySelector('.custom-form')?.classList.remove('active');
      //   // document.querySelector('.drawer-overlay')?.classList.remove('active');
      //   close_custom_drawer();
        
        
      //   if(!savedata && !popup_open){
      //          if(addticart)         originalButton.click();
      //     close_custom_drawer();
      //       if(massage){
      //         const massage_el = document.querySelector('.size-guide-success-massage .message p') || null;
      //         if(massage_el) massage_el.innerText = massage;
      //       }
      //   }else{
      //     updateeditprofile(This);
      //   }
      // }else{
      //   return true;
      //   close_custom_drawer();
      // }
    } else {
      
      This.classList.add('fillsize');

      console.log("This",This);

      return false;
      setTimeout(() => {
          This.classList.remove('fillsize');
      }, 2000);
    }
  // });
}

  
}





function updateeditprofile(This,savedata,popup_open) {
  if(!this) return;
  const massage = This.getAttribute('data-massage') || null;
    if(savedata && popup_open){
        // const popup_el = document.querySelector('#pdp-customize-drawer .custom-form-popup') || null;
        // if(popup_el) popup_el.classList.add('popup_active'); 
        updat_product_from_profile_update(massage);       
    }else{
    updat_product_from_profile_update(massage);
    }
}




function updat_product_from_profile(massage = null){

   const popup_el = document.querySelector('#pdp-customize-drawer .custom-form-popup') || null;
  if(popup_el) popup_el.classList.remove('popup_active');
//   if(massage){
//       const massage_el = document.querySelector('.size-guide-success-massage .message p') || null;
//         if(massage_el) massage_el.innerText = massage;
//           close_custom_drawer();
//   }else{
//     const mainbtn = document.querySelector('button[data-save]');
//     if(mainbtn){

//        massage = mainbtn.getAttribute('data-edit-massage') || null;
//        const massage_el = document.querySelector('.size-guide-success-massage .message p') || null;
//         if(massage_el) massage_el.innerText = massage;
//     }
    
//   }

//   // close_custom_drawer();
// const from_main = document.querySelector('product-info product-form form') || null;
// console.log("from_main",from_main);
// if(!from_main) return; 
//     const formData = new FormData(from_main);
//       const data = Object.fromEntries(formData.entries());
//       data.date = Date.now();

//        const checkbox = document.getElementById("profile_checkbox");

//                 if (checkbox.checked) {
//                   data.default = true;
//                 } else {
//                   data.default = false;
//                 }

//              const profileName = data["properties[Profile Name]"] || null;
//              console.log("from_main profileName",profileName,data);
//           if(profileName) {

//             const formattedData = {};
//                   Object.entries(data).forEach(([key, value]) => {
//                   const match = key.match(/^properties\[(.+)\]$/);

//                   if (match) {
//                       const newKey = match[1];
//                       formattedData[newKey] = value; 
//                   } else {
//                       formattedData[key] = value;
//                   }
//                   });
//                   formattedData['Profile Name'] = profileName;
//                   window.last_add = profileName;
//                   const result = {
//                   [profileName]: formattedData
//                   };
//                   if (!window.customer_data || typeof window.customer_data !== "object") {
//                         window.customer_data = {};
//                     }
//                   Object.keys(result).forEach((key) => {
//                     window.customer_data[key] = result[key];
//                     });
//                   console.log("window.customer_data",window.customer_data);
//                     metfilds_update(window.customer_data,this.submitButton,true,true);
//           }

}


function updat_product_from_profile_update(massage = null){
// console.log("close_custom_drawer",close_custom_drawer);

  if(massage){
      const massage_el = document.querySelector('.size-guide-success-massage .message p') || null;
        if(massage_el) massage_el.innerText = massage;
          // close_custom_drawer();
          // close_custom_drawer_new();
  }else{
    const mainbtn = document.querySelector('button[data-save]');
    if(mainbtn){

       massage = mainbtn.getAttribute('data-edit-massage') || null;
       const massage_el = document.querySelector('.size-guide-success-massage .message p') || null;
        if(massage_el) massage_el.innerText = massage;
    }
    
  }



const from_main = document.querySelector('product-info product-form form') || null;
console.log("from_main",from_main);
if(!from_main) return; 
    const formData = new FormData(from_main);
      const data = Object.fromEntries(formData.entries());
      data.date = Date.now();

       const checkbox = document.getElementById("profile_checkbox");

                if (checkbox.checked) {
                  data.default = true;
                } else {
                  data.default = false;
                }

             const profileName = data["properties[Profile Name]"] || null;
             console.log("from_main profileName",profileName,data);
          if(profileName) {

            const formattedData = {};
                  Object.entries(data).forEach(([key, value]) => {
                  const match = key.match(/^properties\[(.+)\]$/);

                  if (match) {
                      const newKey = match[1];
                      formattedData[newKey] = value; 
                  } else {
                      formattedData[key] = value;
                  }
                  });
                  formattedData['Profile Name'] = profileName;
                  window.last_add = profileName;
                  const result = {
                  [profileName]: formattedData
                  };
                  if (!window.customer_data || typeof window.customer_data !== "object") {
                        window.customer_data = {};
                    }
                  Object.keys(result).forEach((key) => {
                    window.customer_data[key] = result[key];
                    });
                  console.log("window.customer_data",window.customer_data);
                  const originalButton = from_main.querySelector('.product-form [type="submit"].product-form__submit');
                      if(originalButton){
                                  originalButton.click();
                                    close_custom_drawer_new();
                                }
                    // metfilds_update(window.customer_data,this.submitButton,true,true);
          }

}



function save_data_tampororey() {
  const from_main = document.querySelector('product-info product-form form') || null;
if(!from_main) return; 
    const formData = new FormData(from_main);
      const data = Object.fromEntries(formData.entries());
             const profileName = data["properties[Profile Name]"] || null;
          if(profileName) {

            const formattedData = {};
                  Object.entries(data).forEach(([key, value]) => {
                  const match = key.match(/^properties\[(.+)\]$/);

                  if (match) {
                      const newKey = match[1];
                      formattedData[newKey] = value; 
                  } else {
                      formattedData[key] = value;
                  }
                  });
                  formattedData['Profile Name'] = profileName;
                  const result = {
                  [profileName]: formattedData
                  };
                  if (!window.teampdata || typeof window.teampdata !== "object") {
                        window.teampdata = {};
                    }
                  Object.keys(result).forEach((key) => {
                    window.teampdata['teampdata'] = result[key];
                    });
                  
          }
}


document.addEventListener('DOMContentLoaded', function() {
const inputs = document.querySelectorAll('.monogram-options-custom input');

// ✅ Run only if inputs exist
if (inputs.length > 0) {
  inputs.forEach(input => {
    input.addEventListener('change', function() {
      const value = this.value.trim();

      // ✅ If "No Monogram" selected → uncheck & clear all #Monogram_Detail inputs
      if (value === "No Monogram") {
        const monogramInputs = document.querySelectorAll('#Monogram_Detail input');

        monogramInputs.forEach(el => {
          if (el.type === 'checkbox' || el.type === 'radio') {
            el.checked = false;
          }
          if (el.type === 'text' || el.type === 'textarea') {
            el.value = '';
          }
        });
       const standardmonogram = document.querySelector('.standard-monogramoption #Monogram_Detail');
        if (standardmonogram) {
          $(standardmonogram).slideUp(250);
        }
      } else {
       const standardmonogram = document.querySelector('.standard-monogramoption #Monogram_Detail');
        if (standardmonogram) {
          $(standardmonogram).slideDown(250);
        }
      }

      // 👉 Add other logic here if needed
    });
  });
}

   const monogramDetail = document.querySelector('#Monogram_Detail');

    if (monogramDetail && inputs.length > 0) {
      const isVisible = window.getComputedStyle(monogramDetail).display !== 'none';

      if (isVisible) {
        const withMonogramInput = document.querySelector('.monogram-options-custom input[value="With Monogram"]');
        
        if (withMonogramInput) {
          // Uncheck all inputs first
          inputs.forEach(input => input.checked = false);

          // Check the "With Monogram" input
          withMonogramInput.checked = true;
          console.log('✅ "With Monogram" checked on load because #Monogram_Detail is visible');
        }
      }
    }
});


// ============== cart drawer details click
document.addEventListener('click', function (e) {
  const clickedEl = e.target.closest('.details-open');
  if (clickedEl) {
    e.preventDefault();

    const itemProperties = clickedEl.closest('.cart-item')?.querySelector('.item-properties');

    if (itemProperties) {
      itemProperties.classList.toggle('active'); // or 'show', 'visible', etc.
    }
  }
});



const labels = document.querySelectorAll('.product-option__label');
const selectedSpan = document.querySelector('[data-selected-value]');

if (labels.length > 0 && selectedSpan) {

  labels.forEach(label => {

    // Hover
    label.addEventListener('mouseenter', function() {
      const input = document.getElementById(this.getAttribute('for'));
      if (input) {
        selectedSpan.innerText = input.value;
      }
    });

    // Mouse leave → back to selected variant
    label.addEventListener('mouseleave', function() {
      const checkedInput = document.querySelector('.product-option__input:checked');
      
      if (checkedInput) {
        selectedSpan.innerText = checkedInput.value;
      }
    });

  });

}


// function custom_updatecart(updates,open_drawer){
//   fetch(`${routes.cart_update_url}`,{
//     method: 'POST',
//     headers: { "Accept": "application/json", "Content-Type": "application/json" },
//     body:  JSON.stringify({ updates }),
//   })
//   .then(response => response.json())
//   .then(response => {
//     // console.log( response.item_count);
//       const this_cartDrawer = document.querySelector('cart-drawer');

//       if (this_cartDrawer) {
//         this_cartDrawer.refresh(false, response.item_count);
//       } 
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   })
//   .finally((e) => {  
//   });
// }



// ============== register form show
const clicklogin = document.querySelector('.cust-account-text');
if (clicklogin) {
  
clicklogin.addEventListener('click', function (event) {
    event.preventDefault();
    const addclassl =  document.querySelector('#login');
    if (addclassl) {
      addclassl.classList.add("hidden");
    }
    const remover =  document.querySelector('.register-body-form');
    if (remover) {
        remover.classList.remove("hidden");
    }
});
}

const waitForOTPSection = setInterval(() => {
  const otpSection = document.getElementById('mobileOTPLoginSection');
  const otpSectionshow = document.getElementById('loginWithPhoneNumberButton');
  const loginWithEmailButton = document.getElementById('loginWithEmailButton');

  if (otpSection && otpSectionshow) {
    otpSection.style.display = 'none'; // Hide OTP login section

    // Force show other login methods
    otpSectionshow.style.setProperty('display', 'block', 'important');
    loginWithEmailButton.style.setProperty('display', 'none', 'important');

    clearInterval(waitForOTPSection);
  }
}, 300);

setTimeout(() => clearInterval(waitForOTPSection), 10000);


// =====================  login click 
const loginclick = document.querySelector('.form-customer__callout-title a');
if (loginclick) {
  
loginclick.addEventListener('click', function (event) {
    event.preventDefault();
    const loginadd =  document.querySelector('#login');
    const addclassl =  document.querySelectorAll('.form-row , .form-row  button , .recover-link');
   addclassl.forEach(addclassls => {
    if (addclassls) {
      
      loginadd.classList.remove("hidden");
        addclassls.style.display = 'block';
    }
    });
    const remover =  document.querySelector('.register-body-form');
    if (remover) {
        remover.classList.add("hidden");
    }
});
}


function update_preselected(This) {
        if(This){

          if(This.hasAttribute('data-edit-profle-data')) addProfileClass(true);

          console.log("This.value",typeof This.value);
          if(!This.value) return;

      console.log("This.id",This.id);
      if (This.id) {
        const update_main = document.querySelector(`#${This.id}-main`) || null;
        if(update_main){
          update_main.checked = true;
          update_main.dispatchEvent(new Event("input", { bubbles: true }));
          update_main.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }

          const customer_size_data = JSON.parse(This.value);
          console.log("customer_size_data",customer_size_data);
          if(!customer_size_data) return;
          if(!This.value && customer_size_data.length <= 0) return;
            Object.entries(customer_size_data).forEach(([key, value]) => {
                console.log(key, value,value != null);
                if(value != null) populate_prefill_profile(key, value);
              });

        }else{
          console.log(window.teampdata['teampdata']);
          const popup_el = document.querySelector('#pdp-customize-drawer .custom-form-popup') || null;
          // close_custom_drawer();
        if(popup_el) popup_el.classList.remove('popup_active');
          Object.entries(window.teampdata['teampdata']).forEach(([key, value]) => {
                if(value != null)  populate_prefill_profile(key, value);
              });
        }

        window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

}


function update_continay(This) {
 const popup_el = document.querySelector('#pdp-customize-drawer .custom-form-popup') || null;
 if(popup_el) popup_el.classList.remove('popup_active');
  close_custom_drawer(This,false);

  const drawer = document.querySelector("#pdp-customize-drawer");
  drawer.classList.remove('updatere_new');
}


function update_defualt(This) {

  if(!This) return;

 const currant_profile = This.getAttribute('data-name-profile') || null;
 if(!currant_profile) return;
    Object.keys(window.customer_data).forEach((key) => {
      if (key === currant_profile) {
        window.customer_data[key].default = true;
      } else {
        delete window.customer_data[key].default;
      }
    });
metfilds_update(window.customer_data);
  
}



function deleteprofile(This) {
    const profile_name = This.getAttribute('data-profilename');
    const main_waper = This.closest('.size-wrapper'); 
     document.body.classList.add("loadding");

    if (!profile_name || !main_waper) return;

    // Check if the profile exists
    if (window.customer_data && window.customer_data.hasOwnProperty(profile_name)) {
        delete window.customer_data[profile_name];
        metfilds_update(window.customer_data,This);
        main_waper.remove();


    } else {
        console.log(`Profile "${profile_name}" not found.`);
    }
}


function open_size_profile_drawer(This) {

   const first_defualt = document.querySelector('[data-is-defualt]') || null;
  if(first_defualt && !This){
    first_defualt.click();
  }

      const drawer = document.querySelector("#open_size_profile_drawer");
      const overlay = document.querySelector("#close_size_profile_drawer");
      drawer.classList.add("active");
      overlay.classList.add("active");
      document.body.style.overflow = "hidden";
      document.body.classList.add("size_profile_open"); // disable scroll
    }

    function close_size_profile_drawer() {
      const drawer = document.querySelector("#open_size_profile_drawer");
      const overlay = document.querySelector("#close_size_profile_drawer");
      drawer.classList.remove("active");
      overlay.classList.remove("active");
      document.body.style.overflow = ""; // re-enable scroll
      document.body.classList.remove("size_profile_open");
    }


     




const populate_prefill_profile = (propertyClass, propertyMetafield)=>{

  const text_ = propertyMetafield;
  if(propertyClass == 'date' || propertyClass == 'Your_Photo' ) return;
  if(typeof propertyMetafield == 'object' || typeof propertyMetafield == 'boolean'){
  } else{
    propertyMetafield = propertyMetafield.toLowerCase();
  }
  if(propertyClass == 'Profile Name') propertyMetafield = text_;

 
        let  prefill_pop_inputs = document.querySelectorAll(`input[name='properties[${propertyClass}]']`);
        if(prefill_pop_inputs.length <= 0){
              prefill_pop_inputs = document.querySelectorAll(`input[name='${propertyClass}']`);
        }



        if(prefill_pop_inputs.length > 1){
         
          prefill_pop_inputs.forEach((prefill_pop_input) => {
              if(prefill_pop_input.type == 'text'){
                prefill_pop_input.value = text_;
                  prefill_pop_input.setAttribute("data-old-title", text_);
                  // if(prefill_pop_input.name == 'properties[Profile Name]') prefill_pop_input.classList.add('hidden');
              }else{
                if(typeof propertyMetafield == 'boolean'){
                  if(propertyMetafield){
                    prefill_pop_input.checked = true;
                  }else{
                    prefill_pop_input.checked = false;
                  }
                  prefill_pop_input.dispatchEvent(new Event("change", { bubbles: true }));

                }else{

                  if (prefill_pop_input.value.toLowerCase() === propertyMetafield.toLowerCase()) {
                    prefill_pop_input.checked = true;
                    // Trigger events
                    prefill_pop_input.dispatchEvent(new Event("input", { bubbles: true }));
                    prefill_pop_input.dispatchEvent(new Event("change", { bubbles: true }));
                    conformsizeselection(prefill_pop_input);
                }
                }
                
              }
          });

        }
        else if(prefill_pop_inputs.length > 0){
          prefill_pop_inputs.forEach(prefill_pop_input =>{
           
            if(prefill_pop_input.type == 'text'){
                prefill_pop_input.value = text_;
                  prefill_pop_input.setAttribute("data-old-title", text_);
                  //  if(prefill_pop_input.name == 'properties[Profile Name]') prefill_pop_input.classList.add('hidden');
              }else{

                
                if(typeof propertyMetafield == 'boolean'){
                  if(propertyMetafield){
                    prefill_pop_input.checked = true;
                  }else{
                    prefill_pop_input.checked = false;
                  }
                  prefill_pop_input.dispatchEvent(new Event("change", { bubbles: true }));

                }else{

                 prefill_pop_input.value = propertyMetafield;
                }
              }
            
            const decreaseBtn = prefill_pop_input.nextElementSibling;
            const increaseBtn = decreaseBtn ? decreaseBtn.nextElementSibling : null;
            if (decreaseBtn && decreaseBtn.classList.contains('input_decrease')) {
              decreaseBtn.disabled = parseFloat(prefill_pop_input.value) <= parseFloat(prefill_pop_input.min);
            }
            if (increaseBtn && increaseBtn.classList.contains('input_increase')) {
              increaseBtn.disabled = parseFloat(prefill_pop_input.value) >= parseFloat(prefill_pop_input.max);
            }
          }) 
        }
        else{
          console.warn('Please Use the correct selector for input.')
        }
      }



    function conformsizeselection(This) {
      // console.log("THis",This);
      const pearant_ = This.closest('.style_panel_main') || null;

      if(!pearant_) return;
      // console.log("pearant_",pearant_);
      const img_update = pearant_.querySelector('.style_image img') || null;
      const text_update = pearant_.querySelector('.display-value') || null;
      const selecteed = pearant_.querySelector('.style-sub-panel-height input[type="radio"]:checked');
      let selecval_pearant = selecteed.labels?.[0] || null;    

      if(!selecval_pearant){
        const confirm_btn = pearant_.querySelector('.confirm_btn') || null;
        if(confirm_btn){
          confirm_btn.click();
        }
      }

      if(!selecval_pearant || !selecteed )  return;
      if(img_update || text_update) {
        if(img_update)  img_update.src = selecval_pearant.querySelector('.card__image img').src;
        if(text_update)  text_update.innerText = selecteed.value;
        }

      }
      // Capture-Phase: läuft vor dem Toggle/Close-Handler product page
       function isPanelOpen(panel) {
          const sub = panel.querySelector('.style-sub-panel');
          return sub && getComputedStyle(sub).display !== 'none';
        }

        function hideErrors(panel) {
          panel.querySelectorAll('.option-error, .confirm-error').forEach(el => el.style.display = 'none');
        }

        // Klick auf Confirm
        document.addEventListener('click', function (e) {
          const btn = e.target.closest('.confirm_btn');
          if (!btn) return;
          const panel = btn.closest('.style_panel_main');
          if (!panel) return;

          const checked = panel.querySelector('.style-sub-panel-height input[type="radio"]:checked');

          if (!checked) {
            e.stopImmediatePropagation(); // Panel bleibt offen
            e.preventDefault();
            hideErrors(panel);
            panel.querySelector('.option-error').style.display = 'block';
          } else {
            panel.dataset.confirmed = 'true';
            hideErrors(panel);
          }
        }, true);

      // Klick auf ein anderes Layout, während ein Panel offen ist
      document.addEventListener('click', function (e) {
        const styleBtn = e.target.closest('.style-button');
        if (!styleBtn) return;
        const clickedPanel = styleBtn.closest('.style_panel_main');

        const openPanel = Array.from(document.querySelectorAll('.style_panel_main'))
          .find(p => p !== clickedPanel && isPanelOpen(p));
        if (!openPanel) return; // kein anderes Panel offen: normal weiter

        const checked = openPanel.querySelector('.style-sub-panel-height input[type="radio"]:checked');
        const confirmed = openPanel.dataset.confirmed !== 'false';

        if (!checked || !confirmed) {
          e.stopImmediatePropagation(); // anderes Layout öffnet sich nicht
          e.preventDefault();
          hideErrors(openPanel);
          const msg = !checked ? '.option-error' : '.confirm-error';
          openPanel.querySelector(msg).style.display = 'block';
        }
      }, true);

      // Option gewählt: noch nicht bestätigt, Fehler ausblenden
      document.addEventListener('change', function (e) {
        if (!e.target.matches('.style-sub-panel-height input[type="radio"]')) return;
        const panel = e.target.closest('.style_panel_main');
        if (!panel) return;
        panel.dataset.confirmed = 'false';
        hideErrors(panel);
      });

    // }


      function addProfileClass(Its_edit) {
        document.querySelector('.profile-size_chart')?.classList.add('active');
        // document.body.classList.add('active_profile-size');
        // document.querySelector('.overlay-profile')?.classList.add('overlay_profile-size');
        if(Its_edit)  document.body.classList.add('profile-edit-popup-open');
        const from_ = document.querySelector('profile-data-created')?.querySelector('form') || null;
          if(from_) from_.reset();
          const _preselect = document.querySelector('#measurement_unit');
                  if(_preselect) measure_unit_changed_dd(_preselect)
      }
      function closeProfile(){
          const addclass_ = document.querySelector('.profile-size_chart')?.classList.remove('active');
        //   const from_ = document.querySelector('profile-data-created')?.querySelector('form') || null;
        //   if(from_) from_.reset();
        //   document.body.classList.remove('active_profile-size');
        // document.querySelector('.overlay-profile')?.classList.remove('overlay_profile-size');
          document.body.classList.remove('profile-edit-popup-open');
      }



//      function  measure_unit_changed_dd(This){
//         const CM_TO_INCHES = 0.393701;
// const INCHES_TO_CM = 1 / CM_TO_INCHES;
// // console.log("INCHES_TO_CM",INCHES_TO_CM);
// // console.log("CM_TO_INCHES",CM_TO_INCHES);


//         const it_new = This.closest('[data-defualt-select]')
//         let it_new_val = null;
//         if(it_new) it_new_val = it_new.getAttribute('data-defualt-select');
//         // console.log("it_new",it_new);

        
//         const isChecked = This.value;
//         // console.log("isChecked",isChecked);
//         const unit = isChecked == 'inches' ? 'inches' : 'cm';
//         // console.log("unit",unit,"it_new_val",it_new_val);
//         // console.log("it_new_val == unit",it_new_val == unit);
//         if(it_new_val == unit) return;
//         const inputs = document.querySelectorAll('.size_input_main input');
        
//     // console.log(tooltips,"tooltips");
//         inputs.forEach((input, index) => {

//          if (
//           input.name == 'properties[Height (cm)]' ||
//           input.name == 'properties[Weight (lb)]' ||
//           input.name == 'Weight (lb)' ||
//           input.name == 'Height (cm)'
//         ) {
//           return;
//         }
//             const min = parseFloat(input.min);
//             const max = parseFloat(input.max);
//             const value = parseFloat(input.value || 0);

//             console.log("min",min);
//             console.log("max",max);
    
//             if (unit === 'inches') {
//                 input.min = (min * CM_TO_INCHES).toFixed(1);
//                 input.max = (max * CM_TO_INCHES).toFixed(1);
//                 if(input.value){
//                   input.value = (value * CM_TO_INCHES).toFixed(1);
//                 }
//                 // console.log("value",value * CM_TO_INCHES);
//             } else {
//                 input.min = (min * INCHES_TO_CM).toFixed(1);
//                 input.max = (max * INCHES_TO_CM).toFixed(1);
//                 if(input.value){
//                   input.value = (value * INCHES_TO_CM).toFixed(1);
//                 }
//                 // console.log("value",value * INCHES_TO_CM);
//             }

//             // Force the browser to recognize the updated attributes
// input.setAttribute('min', input.min);
// input.setAttribute('max', input.max);
//  if(it_new) it_new.setAttribute('data-defualt-select',unit);
//     const tooltips = input.closest('.size_input_main')?.querySelectorAll('.form-error') || null;
//             if (tooltips.length) {
//                tooltips.forEach((tooltep, index) => {
//                  tooltep.textContent = `Please enter a size between ${parseFloat(input.min)}-${parseFloat(input.max)} ${unit}`;
//                });
//             }

//              const tooltips_ = input.closest('.fit.style-input')?.querySelectorAll('.form-error') || null;
//                   if (tooltips_.length) {
//                     tooltips_.forEach((tooltep, index) => {
//                       tooltep.textContent = `Please enter a size between ${parseFloat(input.min)}-${parseFloat(input.max)} ${unit}`;
//                     });
//                   }
            

//         });
        
//     }


function measure_unit_changed_dd(This) {
  const CM_TO_INCHES = 0.393701;
  const INCHES_TO_CM = 2.54;

  const it_new = This.closest('[data-defualt-select]');
  const previousUnit = it_new?.getAttribute('data-defualt-select') || 'cm';

  const unit = This.value === 'inches' ? 'inches' : 'cm';

  if (previousUnit === unit) return;

  const inputs = document.querySelectorAll('.size_input_main input');

  inputs.forEach((input) => {

    if (
      input.name === 'properties[Height (cm)]' ||
      input.name === 'properties[Weight (lb)]' ||
      input.name === 'Weight (lb)' ||
      input.name === 'Height (cm)'
    ) {
      return;
    }

    // Store original CM values only once
    if (!input.dataset.originalMinCm) {
      input.dataset.originalMinCm = parseFloat(input.min) || 0;
    }

    if (!input.dataset.originalMaxCm) {
      input.dataset.originalMaxCm = parseFloat(input.max) || 0;
    }

    // const originalMinCm = parseFloat(input.dataset.originalMinCm);
    // const originalMaxCm = parseFloat(input.dataset.originalMaxCm);

      const originalMinCm = parseFloat(input.min);
    const originalMaxCm = parseFloat(input.max);

    // Store original value in CM when first available
    if (input.value && !input.dataset.originalValueCm) {
      input.dataset.originalValueCm = parseFloat(input.value) || 0;
    }

    // const originalValueCm = parseFloat(input.dataset.originalValueCm);
    const originalValueCm = parseFloat(input.value);

    let newMin;
    let newMax;
    let newValue;

    if (unit === 'inches') {
      newMin = originalMinCm / CM_TO_INCHES;
      newMax = originalMaxCm / CM_TO_INCHES;
      newValue = originalValueCm / CM_TO_INCHES;
    } else {
      newMin = originalMinCm * CM_TO_INCHES;
      newMax = originalMaxCm * CM_TO_INCHES ;
      newValue = originalValueCm * CM_TO_INCHES ;
    }

    input.min = newMin.toFixed(1);
    input.max = newMax.toFixed(1);

    if (input.value) {
       const displayValue = Number.isInteger(newValue) ? newValue : newValue.toFixed(1); 
      // const displayValue = parseInt(newValue);
      input.value = displayValue;
    }

    input.setAttribute('min', input.min);
    input.setAttribute('max', input.max);

    // Update error messages
    const tooltips =
      input.closest('.size_input_main')?.querySelectorAll('.form-error') || [];

    // tooltips.forEach((tooltip) => {
    //   tooltip.textContent =
    //     `Please enter a size between ${parseFloat(input.min)}-${parseFloat(input.max)} ${unit}`;
    // });

    tooltips.forEach((tooltip) => {
      tooltip.textContent = `Please enter a size`;
    });

    const tooltips_ =
      input.closest('.fit.style-input')?.querySelectorAll('.form-error') || [];

    // tooltips_.forEach((tooltip) => {
    //   tooltip.textContent =
    //     `Please enter a size between ${parseFloat(input.min)}-${parseFloat(input.max)} ${unit}`;
    // });

     tooltips_.forEach((tooltip) => {
      tooltip.textContent = `Please enter a size`;
    });

    

  });

  if (it_new) {
    it_new.setAttribute('data-defualt-select', unit);
  }
}






async function renderCustomerProfiles(itsupdate= false) {

    const data_profile_update = document.querySelectorAll('[data-profile-data-add]');
     const data_profile_update_drawer = document.querySelectorAll('[data-profile-data-add-drawer]');

    if (!data_profile_update.length || !data_profile_update_drawer.length ){
      // if(document.body.hasAttribute('data-customer-id'))   open_size_profile_drawer();
               if(window.last_add){
                 close_custom_drawer();
               }
               return;
    }
document.body.classList.add('loadding');
    try {

        const response = await fetch(`/?section_id=customerprofile`);

        if (!response.ok) {
            throw new Error("Failed to fetch customerprofile section");
        }

        const html = await response.text();

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        const section = tempDiv.querySelector("[data-size-content-main]");
        const section_drawer = tempDiv.querySelector("[data-size-content-drawer]");
      //  console.log(section_drawer,"section_drawer");

        if (!section && !section_drawer) {
            console.warn(
                "[data-size-content-main] not found"
            );
            // if(document.body.hasAttribute('data-customer-id'))   open_size_profile_drawer();
               if(window.last_add){
                 close_custom_drawer();
               }
               document.body.classList.remove('loadding');
            return;
        }

         
        data_profile_update.forEach(element => {
            element.innerHTML = section.innerHTML;
        });

         data_profile_update_drawer.forEach(element => {
            element.innerHTML = section_drawer.innerHTML;
        });

        if(window.last_add){
          const drawer_profile = data_profile_update_drawer[0].querySelector('input[data-name-profile="' + window.last_add + '"]') || null;
          if(drawer_profile){
            drawer_profile.checked = true;
            drawer_profile.dispatchEvent(new Event("change", { bubbles: true }));
          }

          const drawer_profile_ = data_profile_update[0].querySelector('input[data-name-profile="' + window.last_add + '"]') || null;
          if(drawer_profile_){
            drawer_profile_.checked = true;
            drawer_profile_.dispatchEvent(new Event("change", { bubbles: true }));
          }

          close_custom_drawer();
         
        }
          document.body.classList.remove('loadding');
          // if(document.body.hasAttribute('data-customer-id') && itsupdate == false)   open_size_profile_drawer();


    } catch (error) {
        if(window.last_add){
              close_custom_drawer();
        }
        document.body.classList.remove('loadding');
        //  if(document.body.hasAttribute('data-customer-id'))   open_size_profile_drawer();
        console.error(
            "Error fetching customerprofile section:",
            error
        );

    }
}


// Call whenever window.customer_data changes


function tabcustomupdate(This) {

  const parant = This.closest('.p-relative.display-flex') || null;
  if(parant){
  const allredio = parant.querySelectorAll('[type="radio"]') || null;

    allredio.forEach(radio => {
      console.log("document.querySelector(`#${radio.id}-content`)",document.querySelector(`#${radio.id}-content`));
        document.querySelector(`#${radio.id}-content`).style.display = 'none';
    });

   const id = This.id + '-content';
   const contentDiv = document.getElementById(id);
   if(contentDiv) contentDiv.style.display = 'block';
  }
  
}


function tabcustomupdatesizedd(This) {
    const parant = document.querySelector(`#${This.getAttribute('data-id')}`);

    if (parant) {
        parant.checked = true;

        parant.dispatchEvent(new Event('change', {
            bubbles: true
        }));
    }
}


(function() {
  if(document.body.classList.contains('template--customizable-product')){
  renderCustomerProfiles();
 
}


const url = new URL(window.location.href);

if (url.searchParams.get('savefrom') === 'true') {
  const successMessage = document.querySelector('[data-success-massage-profile]');

  if (successMessage) {
     successMessage.classList.remove('hidden');
  }

  url.searchParams.delete('savefrom');
  window.history.replaceState({}, '', url.toString());
}




const drawer = document.querySelector('#pdp-customize-drawer');

  if (!drawer) return;

  /**
   * Get the current value of an element
   */
  function getInputValue(input) {
    const type = (input.type || '').toLowerCase();

    if (type === 'checkbox') {
      return input.checked;
    }

    if (type === 'radio') {
      // Radio value is handled by the radio group.
      const name = input.name;

      if (!name) {
        return input.checked ? input.value : '';
      }

      const checkedRadio = drawer.querySelector(
        `input[type="radio"][name="${CSS.escape(name)}"]:checked`
      );

      return checkedRadio ? checkedRadio.value : '';
    }

    if (input.tagName === 'SELECT' && input.multiple) {
      return Array.from(input.selectedOptions)
        .map(option => option.value)
        .sort()
        .join('|');
    }

    return input.value;
  }

  /**
   * Store the initial/original value
   */
  function setOriginalValue(input) {
    const value = getInputValue(input);

    input.dataset.originalValue = JSON.stringify(value);
  }

  /**
   * Check whether the current value is different
   * from the original value.
   */
  function hasValueChanged(input) {
    const originalValue = input.dataset.originalValue;

    if (originalValue === undefined) {
      setOriginalValue(input);
      return false;
    }

    const currentValue = getInputValue(input);

    try {
      return JSON.stringify(currentValue) !== originalValue;
    } catch (error) {
      return String(currentValue) !== String(originalValue);
    }
  }

  /**
   * Check all inputs inside the drawer.
   */
  function checkDrawerUpdated() {
    
    const inputs = drawer.querySelectorAll(
      'input, textarea, select'
    );

    let hasChanged = false;

    inputs.forEach(input => {

       // Ignore tabs1 radio buttons
    if (
      input.type === 'radio' &&
      input.name === 'tabs1'
    ) {
      return;
    }

      console.log("input.closest('#pdp-customize-drawer')?.classList.contains('active')",input.closest('#pdp-customize-drawer')?.classList.contains('active'));
      if(input.closest('#pdp-customize-drawer')?.classList.contains('active')){
        if (hasValueChanged(input)) {
                hasChanged = true;
              }
      }
    });

    drawer.classList.toggle('updatere_new', hasChanged);
  }

  /**
   * Save initial values.
   */
  function initializeInputs() {

    

    const inputs = drawer.querySelectorAll(
      'input, textarea, select'
    );

    inputs.forEach(input => {

      // Ignore tabs1 radio buttons
    if (
      input.type === 'radio' &&
      input.name === 'tabs1'
    ) {
      return;
    }

      console.log("input.closest('#pdp-customize-drawer')?.classList.contains('active')",input.closest('#pdp-customize-drawer')?.classList.contains('active'));
      if(input.closest('#pdp-customize-drawer')?.classList.contains('active')){
         setOriginalValue(input);
      }
    });

    drawer.classList.remove('updatere_new');
  }

  /**
   * Handle all input changes.
   *
   * change:
   * - checkbox
   * - radio
   * - select
   * - input fields
   *
   * input:
   * - text
   * - number
   * - textarea
   * - range
   * etc.
   */
  drawer.addEventListener('input', function () {
    checkDrawerUpdated();
  });

  drawer.addEventListener('change', function () {
    checkDrawerUpdated();
  });

  /**
   * Initialize
   */
  initializeInputs();





})();

window.collarsize = null;
window.sleevelength = null;
window.fit = null;
window.personalTouch = null;
window.monogramPosition = null;
window.monogramColor = null;
window.monogramFontStyle = null;
window.monogramInitials = null;
window.Weight = null;
window.Height = null;


function checkselectvalues(This) {
  if(document.body.classList.contains('template--customizable-product')) return;
  if (!This) return;
  
  if (This.name === 'properties[Collar Size]') {
    console.log('Collar Size:', This.value);
    window.collarsize = This.value;
    updateselecbutton();
  } else if (This.name === 'properties[Fit]') {
    console.log('Fit:', This.value);
    window.fit = This.value;
    updateselecbutton();
  } else if (This.name === 'properties[Sleeve Length]') {
    console.log('Sleeve Length:', This.value);
    window.sleevelength = This.value;
    updateselecbutton();
  } else if(This.classList.contains("personal-touch")){
    console.log('personal-touch:', This.value);
    window.personalTouch = This.value;
    updateselecbutton();
  } else if(This.name === 'properties[Monogram Position]'){
    console.log('Monogram Position:', This.value);
    window.monogramPosition = This.value;
    updateselecbutton();
  } else if(This.name === 'properties[Monogram Color]'){
    console.log('Monogram Color:', This.value);
    window.monogramColor = This.value;
    updateselecbutton();
  } else if(This.name === 'properties[Monogram Font Style]'){
    console.log('Monogram Font Style:', This.value);
    window.monogramFontStyle = This.value;
    updateselecbutton();
  } else if(This.name === 'properties[Monogram Initials]'){
    console.log('Monogram Initials:', This.value);
    window.monogramInitials = This.value;
    updateselecbutton();
  } else if(This.name === 'properties[Weight]'){
    console.log('Weight:', This.value);
    window.Weight = This.value;
    updateselecbutton();
  } else if(This.name === 'properties[Height]'){
    console.log('Height:', This.value);
    window.Height = This.value;
    updateselecbutton();
  }
}


function updateselecbutton() {  
  const main_button_select = document.querySelector('#size-guide-button');
  const main_test_edit = main_button_select.querySelector('[data-size-guide-button-edit] .size-guide-title') || null;
  console.log("main_button_select",main_button_select);
  console.log("main_test_edit",main_test_edit);

  if(!main_button_select || !main_test_edit) return; 

  if(window.collarsize == null && window.sleevelength == null && window.fit == null){
     main_test_edit.innerHTML = '';
      main_button_select.classList.remove('edit-active');
      return;
  }

  if(window.collarsize != null && window.sleevelength != null && window.fit != null){
   
     main_test_edit.innerHTML = `
      <span class="size-title">Size</span>
      ${window.collarsize ? `<span>${window.collarsize} Collar,</span>` : ''}
      ${window.sleevelength ? `<span>${window.sleevelength} Sleeve,</span>` : ''}
      ${window.fit ? `<span>${window.fit} Fit</span>` : ''}
  `;

  
    tt_valid = checkvalidation_new(true);

    console.log("tt_valid,tt_valid",tt_valid);

    if(tt_valid){
      main_button_select.classList.add('edit-active');
    }

  }

}



function checkvalidation_new() {
                    let isValid = true;
                    let allSizeInputsValid = true;

                    // 🔹 1. Validate normal required sections
                    const allGroups = document.querySelectorAll(".custom-required-check");

                    allGroups.forEach((group) => {
                      const inputs = group.querySelectorAll("input");
                      console.log(inputs, "inputs");

                      if (inputs.length === 0) return;

                      const match = inputs[0].name.match(/properties\[(.*?)\]/);
                      const fieldName = match ? match[1] : "";

                      let errorElement = group.querySelector(".form-error");

                      if (!errorElement) return;

                      const hasValue = [...inputs].some((input) => {
                        if (input.type === "radio" || input.type === "checkbox") {
                          return input.checked;
                        }

                        if (input.type === "text" || input.type === "number") {
                          return input.value.trim() !== "";
                        }

                        return false;
                      });

                      if (!hasValue) {
                        isValid = false;
                        // errorElement.textContent = `Please select ${fieldName}`;
                        // errorElement.style.display = "block";
                      } else {
                        // errorElement.style.display = "none";
                      }
                    });

                     // 🔹 1.1. Validate normal required sections
                      const allGroups_new = document.querySelectorAll(".monogram-input-default");

                      allGroups_new.forEach((group) => {
                        const inputs = group.querySelectorAll("input");
                        console.log(inputs, "inputs");

                        if (inputs.length === 0) return;

                        const match = inputs[0].name.match(/properties\[(.*?)\]/);
                        const fieldName = match ? match[1] : "";

                        let errorElement = group.querySelector(".form-error");

                        if (!errorElement) return;

                        const hasValue = [...inputs].some((input) => {
                          if (input.type === "radio" || input.type === "checkbox") {
                            return input.checked;
                          }

                          if (input.type === "text" || input.type === "number") {
                            return input.value.trim() !== "";
                          }

                          return false;
                        });

                        if (!hasValue) {
                          isValid = false;
                          
                          // errorElement.style.display = "block";
                        } else {
                          // errorElement.style.display = "none";
                        }
                      });

                    // 🔹 2. Validate size inputs
                    const sizeInputs = document.querySelectorAll(
                      ".size-container .size_new_input input, #profile_name"
                    );

                    sizeInputs.forEach((input) => {
                      const parent = input.closest(".size_new_input");
                      const fitInput = input.closest(".fit.style-input");

                      if (!parent) return;

                      const value = parseFloat(input.value);

                      let isInvalid = false;

                      if (input.type === "text") {
                        isInvalid = input.value.trim() === "";
                      } else {
                        isInvalid =
                          input.value.trim() === "" ||
                          isNaN(value);

                        /*
                        // Enable this if min/max validation is required

                        const min = parseFloat(input.min);
                        const max = parseFloat(input.max);

                        isInvalid =
                          input.value.trim() === "" ||
                          isNaN(value) ||
                          isNaN(min) ||
                          isNaN(max) ||
                          value < min ||
                          value > max;
                        */
                      }

                      console.log("isInvalid:", isInvalid);

                      if (isInvalid) {
                        // fitInput?.classList.add("error");

                        allSizeInputsValid = false;
                        isValid = false;
                      } else {
                        // fitInput?.classList.remove("error");
                        // parent.style.border = "";
                      }
                    });

                    // 🔹 3. Manage step/tab visibility
                    const sizeContainer = document.querySelector(".size-container");
                    const styleContainer = document.querySelector(".style-container");

                    const tabMeasurement = document.querySelector(
                      'label.tab[for="measurement"]'
                    );

                    const tabCustomize = document.querySelector(
                      'label.tab[for="customize"]'
                    );

                    if (sizeContainer && styleContainer) {
                      if (allSizeInputsValid) {
                        // sizeContainer.style.display = "none";
                        // styleContainer.style.display = "block";

                        // ✅ Switch to Customize tab
                        if (tabMeasurement) {
                          tabMeasurement.classList.remove("active");
                        }

                        if (tabCustomize) {
                          tabCustomize.classList.add("active");
                        }
                      } else {
                        // sizeContainer.style.display = "block";
                        // styleContainer.style.display = "none";

                        // ⛔ Keep Measurement tab active
                        if (tabMeasurement) {
                          tabMeasurement.classList.add("active");
                        }

                        if (tabCustomize) {
                          tabCustomize.classList.remove("active");
                        }

                        // return false;
                      }
                    }

                    // 🔹 4. Validate Monogram section
                    const withMonogram = document.querySelector(
                      '.monogram-options-custom input[value="With Monogram"]:checked'
                    );

                    if (withMonogram) {
                      const monogramSection = document.querySelector("#Monogram_Detail");

                      if (
                        monogramSection &&
                        window.getComputedStyle(monogramSection).display !== "none"
                      ) {
                        const monogramGroups =
                          monogramSection.querySelectorAll(".d-flex");

                        monogramGroups.forEach((group) => {
                          const inputs = group.querySelectorAll("input");

                          if (inputs.length === 0) return;

                          const match = inputs[0].name.match(/properties\[(.*?)\]/);
                          const fieldName = match ? match[1] : "";

                          let errorElement = group.querySelector(".form-error");

                          // Create error element if it doesn't exist
                          if (!errorElement) {
                            errorElement = document.createElement("p");
                            errorElement.className = "form-error";

                            Object.assign(errorElement.style, {
                              color: "red",
                              fontSize: "13px",
                              marginTop: "4px",
                            });

                            group.appendChild(errorElement);
                          }

                          const hasValue = [...inputs].some((input) => {
                            if (
                              input.type === "radio" ||
                              input.type === "checkbox"
                            ) {
                              return input.checked;
                            }

                            if (
                              input.type === "text" ||
                              input.type === "number"
                            ) {
                              return input.value.trim() !== "";
                            }

                            return false;
                          });

                          if (!hasValue) {
                            isValid = false;

                            // errorElement.textContent = `Please select ${fieldName}`;
                            // errorElement.style.display = "block";
                          } else {
                            // errorElement.style.display = "none";
                          }
                        });
                      }
                    }

                    // 🔹 5. Return final validation result
                    return isValid;
                  }





function update_preselectedreadytowar() {
  if(!document.body.classList.contains('template--customizable-product') ){
        Object.entries(window.customer_data_ready_product['readytowar']).forEach(([key, value]) => {
            if(value != null)  populate_prefill_profilereadytowar(key, value);
          });
  }
  window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

}


const populate_prefill_profilereadytowar = (propertyClass, propertyMetafield)=>{

  const text_ = propertyMetafield;
  if(propertyClass == 'date' || propertyClass == 'Your_Photo'  || propertyClass ==  'properties[Your_Photo]' ||  propertyClass ==  'properties[Your_Photo_get]') return;
  if(typeof propertyMetafield == 'object' || typeof propertyMetafield == 'boolean'){
  } else{
    propertyMetafield = propertyMetafield.toLowerCase();
  }
  if(propertyClass == 'Profile Name') propertyMetafield = text_;

 
        let  prefill_pop_inputs = document.querySelectorAll(`input[name='properties[${propertyClass}]']`);
        if(prefill_pop_inputs.length <= 0){
              prefill_pop_inputs = document.querySelectorAll(`input[name='${propertyClass}']`);
        }



        if(prefill_pop_inputs.length > 1){
         
          prefill_pop_inputs.forEach((prefill_pop_input) => {
              if(prefill_pop_input.type == 'text'){
                prefill_pop_input.value = text_;
                  prefill_pop_input.setAttribute("data-old-title", text_);
                  // if(prefill_pop_input.name == 'properties[Profile Name]') prefill_pop_input.classList.add('hidden');
              }else{
                if(typeof propertyMetafield == 'boolean'){
                  if(propertyMetafield){
                    prefill_pop_input.checked = true;
                  }else{
                    prefill_pop_input.checked = false;
                  }
                  prefill_pop_input.dispatchEvent(new Event("change", { bubbles: true }));

                }else{

                  if (prefill_pop_input.value.toLowerCase() === propertyMetafield.toLowerCase()) {
                    prefill_pop_input.checked = true;
                    // Trigger events
                    prefill_pop_input.dispatchEvent(new Event("input", { bubbles: true }));
                    prefill_pop_input.dispatchEvent(new Event("change", { bubbles: true }));
                    conformsizeselection(prefill_pop_input);
                }
                }
                
              }
          });

        }
        else if(prefill_pop_inputs.length > 0){
          console.log("prefill_pop_inputs",prefill_pop_inputs)
          prefill_pop_inputs.forEach(prefill_pop_input =>{
           
            if(prefill_pop_input.type == 'text'){
                prefill_pop_input.value = text_;
                  prefill_pop_input.setAttribute("data-old-title", text_);
                  //  if(prefill_pop_input.name == 'properties[Profile Name]') prefill_pop_input.classList.add('hidden');
              }else{

                
                if(typeof propertyMetafield == 'boolean'){
                  if(propertyMetafield){
                    prefill_pop_input.checked = true;
                  }else{
                    prefill_pop_input.checked = false;
                  }
                  prefill_pop_input.dispatchEvent(new Event("change", { bubbles: true }));

                }else{

                 prefill_pop_input.value = propertyMetafield;
                }
              }
            
            const decreaseBtn = prefill_pop_input.nextElementSibling;
            const increaseBtn = decreaseBtn ? decreaseBtn.nextElementSibling : null;
            if (decreaseBtn && decreaseBtn.classList.contains('input_decrease')) {
              decreaseBtn.disabled = parseFloat(prefill_pop_input.value) <= parseFloat(prefill_pop_input.min);
            }
            if (increaseBtn && increaseBtn.classList.contains('input_increase')) {
              increaseBtn.disabled = parseFloat(prefill_pop_input.value) >= parseFloat(prefill_pop_input.max);
            }
          }) 
        }
        else{
          console.warn('Please Use the correct selector for input.')
        }
      }


      

function Account_open() {

  const account = document.querySelector('shopify-account[data-wishlist]');
    const accountButton = account?.shadowRoot?.querySelector('.account-button');

    if (accountButton) {
      accountButton.click();
    }
  
}


if(document.body.classList.contains('template--profile')){


   const measurement_tips_tab_ = document.querySelectorAll(".measurement-tips-tab");
       measurement_tips_tab_.forEach((tab) => {
      tab.addEventListener("change", function () {
        const scrollContainer = this.closest('.meansurement_nav_main');
       const label = scrollContainer.querySelector('label[for="' + tab.id + '"]');
          if (label) {
              label.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'   // centers the active tab; use 'nearest' to just nudge it visible
              });
          }

        

        if (this.checked) {
          const selectedValue = this.value;
          const measuring_tip_detail = document.querySelector(".measuring-tip-detail");
          const measuring_tip_image = document.querySelector(".measurement-tips-image");
          if (selectedValue === "neck") {
            measuring_tip_detail.innerHTML = measurement_content.neck.description;
            measuring_tip_image.src = measurement_content.neck.image;
            measuring_tip_image.alt = measurement_content.neck.image_alt;
          } else if (selectedValue === "shoulder") {
            measuring_tip_detail.innerHTML = measurement_content.shoulder.description;
            measuring_tip_image.src = measurement_content.shoulder.image;
            measuring_tip_image.alt = measurement_content.shoulder.image_alt;
          } else if (selectedValue === "chest") {
            measuring_tip_detail.innerHTML = measurement_content.chest.description;
            measuring_tip_image.src = measurement_content.chest.image;
            measuring_tip_image.alt = measurement_content.chest.image_alt;
          } else if (selectedValue === "waist") {
            measuring_tip_detail.innerHTML = measurement_content.waist.description;
            measuring_tip_image.src = measurement_content.waist.image;
            measuring_tip_image.alt = measurement_content.waist.image_alt;
          } else if (selectedValue === "hips") {
            measuring_tip_detail.innerHTML = measurement_content.hips.description;
            measuring_tip_image.src = measurement_content.hips.image;
            measuring_tip_image.alt = measurement_content.hips.image_alt;
          } else if (selectedValue === "shirt_length") {
            measuring_tip_detail.innerHTML = measurement_content.shirt_length.description;
            measuring_tip_image.src = measurement_content.shirt_length.image;
            measuring_tip_image.alt = measurement_content.shirt_length.image_alt;
          } else if (selectedValue === "sleeve_length") {
            measuring_tip_detail.innerHTML = measurement_content.sleeve_length.description;
            measuring_tip_image.src = measurement_content.sleeve_length.image;
            measuring_tip_image.alt = measurement_content.sleeve_length.image_alt;
          } else if (selectedValue === "wrist") {
            measuring_tip_detail.innerHTML = measurement_content.wrist.description;
            measuring_tip_image.src = measurement_content.wrist.image;
            measuring_tip_image.alt = measurement_content.wrist.image_alt;
          } else {
            measuring_tip_detail.innerHTML = measurement_content.neck.description;
            measuring_tip_image.src = measurement_content.neck.image;
            measuring_tip_image.alt = measurement_content.neck.image_alt;
          }
        }
      });
    }); 
  }